/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  LetterlistTableColumnSettingType,
} from "features/Letterbooks/types";
import LetterBookColumns from "features/Letterbooks/components/cards/LetterbookTableRow/columns/ColumnSettings";
import {
  appendUserToColumns,
  calculateUnusedColumns,
} from "./utils";
import { LetterbooksSerializersLetterbooks, UserSerializersUserByline } from "types/serializers";
import useCurrentUser from "hooks/fragments/useCurrentUser";

// Book
const bookColumns: LetterlistTableColumnSettingType[] = [
  LetterBookColumns.ContentWarnings,
  LetterBookColumns.Details,
  LetterBookColumns.Genres,
  LetterBookColumns.Length,
  LetterBookColumns.Moods,
  LetterBookColumns.Rating,
  LetterBookColumns.ReadersCount,
  LetterBookColumns.ReleaseDate,
  LetterBookColumns.ReleaseYear,
  LetterBookColumns.UsersCount,
];

// User
const userNotOwnerColumns: LetterlistTableColumnSettingType[] = [
  LetterBookColumns.CurrentUserRating,
];
const userColumns: LetterlistTableColumnSettingType[] = [
  LetterBookColumns.BookButton,
];

// Pro
const proColumns: LetterlistTableColumnSettingType[] = [
  LetterBookColumns.Match,
];

function calculatePossibleColumns(currentUser: UserSerializersUserByline | null) {
  return [
    ...bookColumns,
    ...(currentUser ? appendUserToColumns(userColumns, currentUser) : []),
    ...(currentUser?.pro ? appendUserToColumns(proColumns, currentUser) : []),
  ];
}

export default function PublisherTableColumns({
  context,
  overrides,
}: {
  context: LetterbooksSerializersLetterbooks;
  overrides: string[];
}) {
  const currentUser = useCurrentUser();

  const possibleColumns = calculatePossibleColumns(currentUser);

  // If overrides are provided, use the valid ones
  if (overrides.length > 0) {
    // Remove columns they shouldn't be able to see or that don't exist
    const matchingColumns = overrides
      .map((override) =>
        possibleColumns.find((column) => column.key === override)
      )
      .filter((column) => column);
    if (matchingColumns.length > 0) {
      return {
        tableColumns: matchingColumns,
        unusedColumns: calculateUnusedColumns(matchingColumns, possibleColumns),
      };
    }
  }

  const columns: LetterlistTableColumnSettingType[] = [
    LetterBookColumns.Details,
  ];
  columns.push(LetterBookColumns.ReleaseYear);
  columns.push(LetterBookColumns.ReadersCount);
  columns.push(LetterBookColumns.Rating);
  columns.push(LetterBookColumns.BookButton);

  return {
    tableColumns: columns,
    unusedColumns: calculateUnusedColumns(columns, possibleColumns),
  };
}
